import { FC, ReactNode, useMemo } from 'react'
import BG1920 from '../../icons/BG1920.png'
import BG1440 from '../../icons/BG1440.png'
import BG1280 from '../../icons/BG1280.png'
import BG1024 from '../../icons/BG1024.png'
import BG768 from '../../icons/BG768.png'
import BG540 from '../../icons/BG540.png'
import BG360 from '../../icons/BG360.png'
import Logo from '../../icons/logo.svg'
import { Button } from '../button'

import { textBtn } from './mock'
import cls from './styles.module.scss'
import { TextLandDe } from './ui/text-land/de/TextLandDe'
import { TextLandEn } from './ui/text-land/en/TextLandEn'
import { TextLandRo } from './ui/text-land/ro/TextLandRo'
import { TextLandEs } from './ui/text-land/es/TextLandEs'
import { useControlModal, ModalType } from '@rockstar/registration-component'

import { normalizeBrowserLang, TLang } from 'src/constants/langs'
import { SignUp } from 'src/features/registration/SignUp'
import { getTextByLang } from 'src/shared/utils/getTextByLang'

const TraficLand: FC = () => {
    const { modalType, setModalType } = useControlModal()

    const currentLang = useMemo<TLang>(() => {
        const nav = typeof navigator !== 'undefined' ? navigator.language : 'en'
        return normalizeBrowserLang(nav)
    }, [])

    const MODALS = useMemo<{ [key in ModalType]: ReactNode | null }>(
        () => ({
            sign_up: <SignUp language={currentLang} />,
            clear: null,
        }),
        [currentLang],
    )

    const renderContent = () => {
        switch (currentLang) {
            case 'ro':
                return <TextLandRo />
            case 'de':
                return <TextLandDe />
            case 'es':
                return <TextLandEs />
            default:
                return <TextLandEn />
        }
    }

    return (
        <div className={cls.root}>
            <picture className={cls.picture}>
                <source media="(min-width: 1920px)" srcSet={BG1920} />
                <source media="(min-width: 1440px)" srcSet={BG1440} />
                <source media="(min-width: 1280px)" srcSet={BG1280} />
                <source media="(min-/width: 1024px)" srcSet={BG1024} />
                <source media="(min-width: 768px)" srcSet={BG768} />
                <source media="(min-width: 540px)" srcSet={BG540} />
                <source media="(min-width: 320px)" srcSet={BG360} />
                <img src={BG1024} alt="bg-main" className={cls.main_bg} />
            </picture>
            <div>
                <img src={Logo} alt="Logo" className={cls.wrapper_logo} />
            </div>
            <div className={cls.container}>
                <div className={cls.main_wrapper}>
                    <div className={cls.anime_container}>
                        <div className={cls.main_anime_wrapper} />
                        <div className={cls.music_circle} />
                    </div>
                    <div className={cls.main_content_wrapper}>
                        {renderContent()}

                        <Button
                            variant="primary"
                            className={cls.button}
                            onClick={() => setModalType('sign_up')}
                        >
                            {getTextByLang(currentLang, textBtn)}
                        </Button>
                    </div>
                </div>
            </div>
            {MODALS[modalType]}
        </div>
    )
}

export default TraficLand
